export default __webpack_public_path__ + "static/media/print.e23906e1.svg";